import React from "react";
import PropTypes from "prop-types";
import { IconButton, Flex } from "@evertrue/et-components";
import { useChatNavigationContext } from "../contexts/chat-navigation-context";

const Header = ({ title, roomId, onBack, showBack, showSettings, showClose }) => {
  const [, dispatch] = useChatNavigationContext();
  const navBack = () => dispatch({ type: "HOME" });
  const handleBack = onBack || navBack;
  return (
    <Flex className="chat-header">
      <div className="chat-header-grouping">
        {/* TODO - hook up go back */}
        {showBack && <IconButton title="back" icon="chevron-left" className="chat-header-icon" onClick={handleBack} />}
        <span className="chat-header-title">{title}</span>
      </div>
      <div className="chat-header-grouping">
        {showSettings && (
          <IconButton
            title="room settings"
            icon="settings"
            className="chat-header-icon"
            onClick={() => dispatch({ type: "ROOM_SETTINGS", payload: roomId })}
          />
        )}
        {showClose && (
          <IconButton
            title="close chat"
            icon="close"
            className="chat-header-icon chat-header-icon--close"
            onClick={() => dispatch({ type: "CLOSE_PANEL" })}
          />
        )}
      </div>
    </Flex>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  showBack: PropTypes.bool,
  showSettings: PropTypes.bool,
  showClose: PropTypes.bool,
  onBack: PropTypes.func,
};

export default Header;
